import React from "react"
import Paper from "../../ui/Paper"

import { useDispatch, useSelector } from "react-redux"
import { selectUserAccountsById, totpRequired } from "./slice"
import LoadingSpinner, { Backdrop } from "../../ui/LoadingSpinner"
import styled from "styled-components"

import Button from "../../ui/Button"

import ErrorMsg from "../../ui/ErrorMsg"
import PropTypes from "prop-types"
import { slideFromRight } from "../../ui/animations"
import ActionsFooter from "../../ui/ActionsFooter"
import ID from "../../ui/ID"

const Panel = styled(Paper)`
  padding: 2rem;
  overflow-y: auto;
  width: 25vw;
  min-width: 20rem;
  max-width: 40rem;
  animation: 0.3s ${slideFromRight} ease-out;
`
const FormContainer = styled.div``

/**
 * Un-enroll a user from requiring 2FA to log in.
 */
const Cancel2FA = ({ id, handleCancel }) => {
  const dispatch = useDispatch()
  const accountsByID = useSelector(selectUserAccountsById)
  const account = accountsByID[id]

  const onSubmit = () => {
    dispatch(totpRequired({ id, required: false }))
      .unwrap()
      .then(() => {
        handleCancel()
      })
  }

  return (
    <Panel>
      <h2>Cancel 2FA</h2>
      {account?._saveStatus === "updating" && (
        <Backdrop>
          <LoadingSpinner />
        </Backdrop>
      )}

      <FormContainer>
        <p>
          By proceeding, you will <strong>remove</strong> the requirement for{" "}
          <ID>{id}</ID> to log in using an authenticator code, rendering the
          account less-secure.
        </p>
        <ActionsFooter>
          {handleCancel && <Button onClick={handleCancel}>Close</Button>}
          <Button onClick={onSubmit} delete>
            Submit
          </Button>
        </ActionsFooter>
        {account?._saveStatus == "rejected" && (
          <ErrorMsg
            msg={account._errorMessage || "Something went wrong"}
            showIcon={true}
          />
        )}
      </FormContainer>
    </Panel>
  )
}

Cancel2FA.propTypes = {
  id: PropTypes.string, // email of the account
  handleCancel: PropTypes.func, // Cancel add role
}
export default Cancel2FA
